import React, { Component } from "react";
import { connect } from "react-redux";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import Button from "../../components/Button/Button";
import StringInput from "../../components/Input/StringInput/StringInput";
import { filterErrorHandler, formValidation } from "../../hoc/Shared/utility";
import Swal from "sweetalert2";
import { withNamespaces } from "react-i18next";
import ValidationError from "../../components/ValidationError/ValidationError";
import DataTable from "../../components/Datatable/DataTable";
import FreeSpinMemberSample from "../../assets/sample/free_spin_member.csv";

import * as actions from '../../store/ducks/slotFreeSpin/actions';

class SlotFreeSpinAddMember extends Component 
{
    constructor(props) 
    {
        // const { t } = props;

        super(props);
        this.state = 
        {
            touched: false,
            error_message: [],
            uploadFile: null,
            freeSpinMemberArray: [],

            page: 1,
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            order: null,
            totalPages: 0,
            activePage: 1,
            totalRecords: 0,
            searchValue: "",
            search: "",
            downloadUrl: "",
            username: '',
            loading: false,
        };
        this.onInputChange = this.onInputChange.bind(this);
    }

    componentDidMount() 
    {
        formValidation("free_spin_form");

        let params = {};
        params.id = this.props.selectId;
        this.props.funcGetFreeSpinMember(params);
    }

    shouldComponentUpdate(nextProps, nextState) 
    {
        if (nextProps.rs !== this.props.rs && nextProps.rs !== undefined) 
        {
            if (nextProps.rs.responseCode === 200 && nextProps.rs.msgType === 'success')
            {
                let freeSpinMemberArray = [];

                nextProps.rs.data.result.row.map((val) => {
                    freeSpinMemberArray.push(val.username);
                    return null;
                });

                this.setState({
                    loading: false,
                    freeSpinMemberArray: freeSpinMemberArray,
                    totalPages: nextProps.rs.data.result.pagination.total_page,
                    activePage: nextProps.rs.data.result.pagination.current_page,
                    totalRecords: nextProps.rs.data.result.pagination.total_record,
                    downloadUrl: nextProps.rs.data.downloadUrl,
                });
            }
            else
            {
                this.setState({
                    loading: false,
                }, () => 
                {
                    filterErrorHandler(nextProps.rs.message);
                });
                Swal.close();
            }
        }

        if (nextProps.memberStore !== this.props.memberStore && nextProps.memberStore !== undefined) 
        {
            if (nextProps.memberStore.responseCode === 200 && nextProps.memberStore.msgType === 'success') 
            {
                this.setState({ touched: false });
                const { t } = this.props;
                Swal.fire({
                    title: t("global.record-saved"),
                    icon: nextProps.memberStore.msgType,
                    confirmButtonText: t("global.ok"),
                }).then((result) => 
                {
                    if (result.isConfirmed) 
                    {
                        this.props.refreshHandler();
                        this.props.changePageHandler("listing");
                    }
                });
            } 
            else 
            {
                this.setState({
                    touched: true,
                    error_message: nextProps.memberStore.message,
                });
                Swal.close();
            }
        }

        return true;
    }

    onFilterUsername = (e) => 
    {
        this.setState({
            username: e.target.value
        });
    }

    onInputChange = (event) => 
    {
        this.setState({
            uploadFile: event.target.files[0]
        });
    }

    downloadHandler = () => 
    {
        const link = document.createElement('a');
        link.href = FreeSpinMemberSample;
        link.setAttribute('download', 'free_spin_member.csv');
        document.body.appendChild(link);
        link.click();
    }

    refreshHandler = () => 
    {
        this.setState({
            loading: true,
            freeSpinMemberArray: [],
        }, ()=> {
            let params = {};
            params.id = this.props.selectId;
            params.username = this.state.username;
            this.props.funcGetFreeSpinMember(params);
        });
    }

    submitHandler = (e) => 
    {
        e.preventDefault();
        const { t } = this.props;

        if (!(this.state.uploadFile)) 
        {
            Swal.fire({
                title: t("global.error"),
                icon: "error",
                html: t('slot-free-spin.select-file'),
                showConfirmButton: true,
                confirmButtonText: t("global.ok")
            });
        }
        else 
        {
            Swal.fire({
                title: t("global.confirmation"),
                text: t("global.are-you-sure"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: t("global.save"),
                cancelButtonText: t("global.cancel"),
            }).then((result) => 
            {
                if (result.isConfirmed) 
                {
                    Swal.fire({
                        title: "",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                        didOpen: () => {
                            Swal.showLoading();
                        },
                    });              
    
                    let formData = new FormData();
                    formData.append("id",this.props.selectId);
                    formData.append("uploadFile[]", this.state.uploadFile);

                    // for (var pair of formData.entries()) 
                    // {
                    //      console.log(pair[0]+ ' = ' + pair[1]);
                    // }

                    this.props.funncAddFreeSpinMember(formData);

                    this.setState({
                        uploadFile: null
                    });
                }
            });
        }
    };

    noFormatter = (cell, row, rowIndex) => 
    {
        //let rowNumber = (this.state.activePage - 1) * this.state.limit + (rowIndex + 1);
        let rowNumber = this.state.totalRecords - rowIndex - (this.state.activePage - 1) * this.state.limit;
        return <span>{rowNumber}</span>;
    };

    datatablesChangeHandler = (val, act) => 
    {
        this.setState(
            {
                [act]: act === "searchValue" ? val.target.value : val,
                loading: true,
                data: [],
            },
            () => {
                const listingArr = this.fetchData();
                this.props.funcGetFreeSpinMember(listingArr);
            }
        );
    };

    fetchData = () => 
    {
        const listingArr = {};
        let availablePage = this.state.activePage;

        if (this.state.totalRecords !== 0) {
            availablePage = parseInt(this.state.totalRecords / this.state.limit + 1);
            this.state.activePage >= availablePage && this.setState({ activePage: availablePage });
        }
        listingArr.id = this.props.selectId;
        listingArr.page = this.state.activePage >= availablePage ? availablePage : this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.search = this.state.searchValue;
        listingArr.order = JSON.stringify(this.state.order);
        return listingArr;
    };

    render() 
    {
        let dataListing = [];
        const { t } = this.props;

        const columns = [
            {text: t('global.no'), dataField: "no", formatter: this.noFormatter, headerStyle: { width: '60px' }},
            {text: t('slot-free-spin.username'), dataField: "username"}
        ];

        if (this.state.freeSpinMemberArray.length > 0) 
        {
            dataListing = this.state.freeSpinMemberArray.map((val, idx) => {
                return {
                    username: val
                };
            });
        }

        return (
            <Auxiliary>
                <div className="breadcrumb-header">
                    <div className="d-flex">
                        <div className="my-auto">
                            <Button
                                typeButton="button"
                                classValue="btn btn-back-outline"
                                idValue="back"
                                buttonName={<i className="angle fe fe-chevron-left"></i>}
                                clicked={() => this.props.changePageHandler("listing")}
                            />
                        </div>
                    </div>
                    <div className="my-auto">
                        <div className="d-flex">
                            <h4 className="content-title mb-0 my-auto ml-2">{t("side-bar.slot_free_spin")}</h4>
                        </div>
                    </div>
                </div>
                <div className="row row-sm">
                    <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12">
                        <div className="card box-shadow-0">
                            <div className="card-header">
                                <h4 className="card-title mb-1">{this.props.referenceCode} ({t(`vendor.${this.props.vendorSlug}`)}) - {t("slot-free-spin.add-free-spin-member")}</h4>
                            </div>
                            <div className="card-body pt-0">
                                <form method="post" id="free_spin_form" className="form-horizontal" onSubmit={this.submitHandler} noValidate>
                                    <ValidationError formName="free_spin_form" touched={this.state.touched} message={this.state.error_message} />
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <input
                                                    id='file'
                                                    name='file'
                                                    type='file'
                                                    onChange={this.onInputChange}
                                                    className="filter-input"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                    <label className="font-weight-bolder">
                                                        {t("slot-free-spin.username")}
                                                    </label>
                                                    <StringInput
                                                        id="username"
                                                        name="username"
                                                        value={this.state.username}
                                                        onChange={this.onFilterUsername}
                                                        className="filter-input"
                                                        onSearchPress={(evt) =>
                                                            evt.key === "Enter" &&
                                                            this.refreshHandler()
                                                        }
                                                        autoComplete="off"
                                                    />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group mb-0 mt-3 justify-content-end">
                                        <div>
                                            <Button typeButton="submit" classValue="btn btn-blue" idValue="submit" buttonName={t("global.save")} />
                                            {(()=>{
                                                if(this.state.downloadUrl){
                                                    return <a href={this.state.downloadUrl}>
                                                        <Button typeButton="button" classValue="btn btn-secondary ml-1" idValue="download" buttonName={t("slot-free-spin.download")} />
                                                    </a>
                                                }
                                                else{
                                                    return <Button typeButton="button" classValue="btn btn-secondary ml-1" idValue="download" buttonName={t("slot-free-spin.download")} clicked={this.downloadHandler} />
                                                }
                                            })()}

                                            <Button typeButton="button" classValue="btn btn-blue" idValue="filter" buttonName={t("global.filter")} clicked={() => this.refreshHandler() } />
                                        </div>
                                    </div>
                                </form>

                                <div className="table-responsive table-hover datatable">
                                    <DataTable
                                        keyField="systemSettingsId"
                                        data={dataListing}
                                        columns={columns}
                                        activePage={this.state.activePage}
                                        limit={this.state.limit}
                                        totalItems={this.state.totalRecords}
                                        paginationHandler={(val) => this.datatablesChangeHandler(val, "activePage")}
                                        sorted={this.state.order}
                                        sizePerPageHandler={(val) => this.datatablesChangeHandler(val, "limit")}
                                        searchValue={this.state.searchValue}
                                        classValue="dataTable table-bordered text-justify text-center"
                                        loading={this.state.loading}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Auxiliary>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        rs: state.slotFreeSpin.member,
        memberStore: state.slotFreeSpin.memberStore,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        funcGetFreeSpinMember: (data) => dispatch(actions.getFreeSpinMember(data)),
        funncAddFreeSpinMember: (data) => dispatch(actions.addFreeSpinMember(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(SlotFreeSpinAddMember));
